import React, { useState, useMemo } from 'react';

import { $createParagraphNode, $getSelection, LexicalEditor } from 'lexical';

import { useValidationService } from '../../../../../services/hooks';
import { Dialog, DialogContent } from '../../../../../Dialog';
import { Button } from '../../../../../Button';
import { TextInput } from '../../../../../input';
import { $createQuoteNode } from '../../../nodes/QuoteNode';
import { useForm } from '../../hooks';

interface QuoteDialogProps {
  editor: LexicalEditor;
  open: boolean;
  onClose: () => void;
  selectionText?: string;
}

interface QuoteDialogForm {
  quote: string;
}

export const QuoteDialog = ({
  editor,
  open,
  onClose,
  selectionText,
}: QuoteDialogProps) => {
  const [quote, setQuote] = useState(selectionText || '');
  const [author, setAuthor] = useState('');
  const validator = useValidationService();

  const allValues = useMemo(() => {
    return {
      quote,
    };
  }, [quote]);

  const fieldValidators = useMemo(() => {
    return {
      quote: [validator.required<QuoteDialogForm>('Обязательное поле')],
    };
  }, [validator]);

  const { errors, touched, validateField, hasValidationErrors, handleBlur } =
    useForm<QuoteDialogForm>(allValues, fieldValidators);

  const handleChangeQuoteInput = async (value?: string) => {
    setQuote(() => value || '');
    await validateField('quote', value);
  };

  const handleChangeAuthorInput = (value?: string) => {
    setAuthor(() => value || '');
  };

  const onSubmit = () => {
    editor.update(() => {
      const selection = $getSelection();
      const quoteNode = $createQuoteNode(quote, author);
      const paragrapnNode = $createParagraphNode();

      selection?.insertNodes([quoteNode, paragrapnNode]);

      onClose();
    });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <form onSubmit={onSubmit}>
        <DialogContent
          title="Добавление цитаты"
          onClose={onClose}
          actions={
            <>
              <Button
                size="large"
                variant="tertiaryLight"
                type="button"
                onClick={onClose}
              >
                Отменить
              </Button>
              <Button
                disabled={hasValidationErrors}
                size="large"
                variant="primary"
                type="submit"
              >
                Добавить
              </Button>
            </>
          }
        >
          <TextInput
            label="Цитата"
            required
            placeholder="Введите текст"
            value={quote}
            onChange={handleChangeQuoteInput}
            name="text"
            error={touched.quote && !!errors.quote}
            helperText={touched.quote ? errors.quote : undefined}
            onBlur={handleBlur('quote')}
          />

          <TextInput
            label="Автор"
            placeholder="Добавьте автора цитаты"
            value={author}
            onChange={handleChangeAuthorInput}
            clearable
            name="link"
          />
        </DialogContent>
      </form>
    </Dialog>
  );
};
